import axios from 'axios';

// Dedicated axios instance for EDRMS endpoints. Shares the app's auth token/cookie.
const edrmsApi = axios.create({ baseURL: '/api/edrms', withCredentials: true });

edrmsApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

edrmsApi.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      if (!onLogin) {
        localStorage.removeItem('flowup_token');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

edrmsApi.get = (url, config) => edrmsApi({ method: 'get', url, ...config });
edrmsApi.post = (url, data, config) => edrmsApi({ method: 'post', url, data, ...config });
edrmsApi.postForm = (url, formData, config) => edrmsApi({ method: 'post', url, data: formData, headers: { 'Content-Type': 'multipart/form-data' }, ...config });
edrmsApi.put = (url, data, config) => edrmsApi({ method: 'put', url, data, ...config });
edrmsApi.delete = (url, config) => edrmsApi({ method: 'delete', url, ...config });

// Status metadata for outgoing + incoming letters.
export const OUT_STATUS = {
  draft: { label: 'Draft', color: '#6B7280', bg: 'rgba(107,114,128,0.12)' },
  under_review: { label: 'Under Review', color: '#D97706', bg: 'rgba(217,119,6,0.12)' },
  returned: { label: 'Returned for Amendment', color: '#DC2626', bg: 'rgba(220,38,38,0.12)' },
  approved: { label: 'Approved for Signature', color: '#2563EB', bg: 'rgba(37,99,235,0.12)' },
  pending_signature: { label: 'Pending Signature', color: '#7C3AED', bg: 'rgba(124,58,237,0.12)' },
  issued: { label: 'Issued', color: '#16A34A', bg: 'rgba(22,163,74,0.12)' },
  archived: { label: 'Archived', color: '#0D9488', bg: 'rgba(13,148,136,0.12)' },
  cancelled: { label: 'Cancelled', color: '#9CA3AF', bg: 'rgba(156,163,175,0.12)' },
};
export const IN_STATUS = {
  registered: { label: 'Registered', color: '#6B7280', bg: 'rgba(107,114,128,0.12)' },
  assigned: { label: 'Assigned', color: '#2563EB', bg: 'rgba(37,99,235,0.12)' },
  in_action: { label: 'In Action', color: '#D97706', bg: 'rgba(217,119,6,0.12)' },
  closed: { label: 'Closed', color: '#16A34A', bg: 'rgba(22,163,74,0.12)' },
};
export const RECEIVED_VIA = { email: 'Email', hand: 'Hand Delivery', courier: 'Courier', gov_system: 'Government Correspondence System' };
export const ACTIONS = { info: 'For Information (للعلم)', reply: 'For Reply (للرد)', follow_up: 'For Follow-up (للمتابعة)', file: 'For Filing (للحفظ)' };

export const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-GB') : '';

export default edrmsApi;
